import React, { Fragment } from 'react'
import { FormSubmit, FormWrapper } from '@myxplor/forms'

const GovActionDone = ({ onClick, children }) => (
  <FormWrapper
    onSubmit={onClick}
    render={() => (
      <Fragment>
        {children}
        <FormSubmit>Done</FormSubmit>
      </Fragment>
    )}
  />
)

export default GovActionDone



// WEBPACK FOOTER //
// ./src/ui/gov-actions/views/complete.jsx